/**
 * @description Extract organization ID from key_chat for presence channel subscription
 * @param keyChat - Base64 encoded key_chat from user employee data
 * @returns Organization ID or null if invalid
 */

export const getUserPresenceId = (keyChat: string | undefined): number | null => {
  if (!keyChat) return null;

  try {
    const decoded = atob(keyChat.trim());
    const parts = decoded.split("/");

    if (parts.length !== 2) return null;

    const organizationId = Number(parts[0]);
    const result = Number.isNaN(organizationId) ? null : organizationId;

    return result;
  }
  catch {
    return null;
  }
};
